import { axiosAdminApiClient } from "..";
import { handleError } from "../../utils/errors";

class AdminService {
  getInfoAboutAdmin = async () => {
    try {
      const response = await axiosAdminApiClient.get("/auth/profile");
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data.data;
      return { admin: user };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching admin's info.");
    }
  };

  getUsersForAdmin = async ({ page, search, limit, status }) => {
    try {
      let url = `/users?page=${page}&limit=${limit}`;
      if (search && search.trim() !== "") {
        url += `&search=${encodeURIComponent(search)}`;
      }
      if (status && status !== "all") {
        url += `&status=${status}`;
      }
      const response = await axiosAdminApiClient.get(url);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching all users for admin.",
      );
    }
  };

  updateUserStatus = async ({ userId, status }) => {
    try {
      const response = await axiosAdminApiClient.patch(
        `/auth/users/${userId}/status`,
        {
          status,
        },
      );
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating user status.");
    }
  };

  deleteUser = async (userId) => {
    try {
      const response = await axiosAdminApiClient.delete(
        `/auth/users/${userId}`,
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting user.");
    }
  };

  updateUserRole = async ({ userId, role }) => {
    try {
      const response = await axiosAdminApiClient.patch(
        `/auth/users/${userId}/role`,
        {
          role,
        },
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating user role.");
    }
  };

  getDashboardAnalytics = async (period = "all") => {
    try {
      let url = "/analytics/dashboard";
      if (period && period !== "all") {
        url += `?period=${period}`;
      }
      const response = await axiosAdminApiClient.get(url);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching dashboard analytics.",
      );
    }
  };

  getDetailedAnalytics = async ({ period, startDate, endDate } = {}) => {
    try {
      let url = "/analytics/detailed";
      const params = new URLSearchParams();

      if (period) params.append("period", period);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axiosAdminApiClient.get(url);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching detailed analytics.",
      );
    }
  };
}

const adminService = new AdminService();

export default adminService;
